module.exports = __webpack_public_path__ + "static/img/S.dea16c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/S.png
// module id = E48+
// module chunks = 0